import * as components from './components'

export default [
  {
    path: '/tagging/list',
    component: components.TagConfiguration,
    name: 'tagList',
    props: true
  },
  {
    path: '/tagging/create',
    component: components.CreateTagType,
    name: 'createTagType',
    props: true
  },
  {
    path: '/tagging/:uuid/edit',
    component: components.CreateTagType,
    name: 'editTagType',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/tagging/routes.js